//components / actions
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Alert } from "reactstrap";
import OtpVerificationContainer from "../OtpVerification/OtpVerificationContainer";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { Modal } from "../CustomModal/Modal";
import { LoginAction } from "./LoginAction";
import CommonUtils from "../../Utils/CommonUtils";
import Divider from "../Divider/Divider";
import CustomSpinner from "../Spinner/Spinner";

//libraries/ constants/ utils
import { Strings } from "../../Resources/Strings/i18n";
import { PATHS } from "./../../Constants";
import {
  OperationStatus,
  APIResponse,
  GOOGLE_WEB_CLIENT_ID,
} from "../../Communication/Constants";
import ReactCustomFlagSelect from "react-custom-flag-select";
import FLAG_SELECTOR_OPTION_LIST from "../../Countries";
import { PhoneNumberUtil } from "google-libphonenumber";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';

//resources / images
import AllWellLogoImg from "../../Resources/Images/img_logo.png";
import LoginBannerImg from "../../Resources/Images/img_login.png";
import ic_google from "../../Resources/Images/ic_google@2x.png";

//stylings
import "react-custom-flag-select/lib/react-custom-flag-select.min.css";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first_name: "",
      last_name: "",
      user_type: undefined,
      mobileNumberValue: "",
      mobileNumberError: false,
      mobileNumberValid: false,
      callingCode: "+1",
      isValid: false,
      toggleModal: false,
      invalidNumberMessageOpen: false,
      mobileNotRegisteredMessageOpen: false,
      isNetworkError: false,
      errorMessage: "",
      isValidName: false,
      spinner: false,
      first_nameError: false,
      emailValue: "",
      emailError: false,
      loginByEmail: false,
      isSubmitBtnDisabled: true,
      existingUserSignIn: false
    };
    this.LoginAction = new LoginAction();
  }
  componentDidMount() {
    if (
      (this.props.currentUserInfo && this.props.currentUserInfo.id !== "") ||
      (this.props.inviteTokenInfo && this.props.inviteTokenInfo.isInvitedUser)
    )
      this.props.history.push(PATHS.HOME);
  }
  enterPress_Login = (event) => {
    if (event.charCode === 13) {
      this.proceedToOtpPage();
    }
  };

  isMobileValid = (mobileNumber) => {
    return (
      !mobileNumber.trim().match("^[0]+$") &&
      mobileNumber.trim().match("^[0-9]*$") &&
      mobileNumber.trim().length === 10
    );
  };

  isValidNumber(mobileNumber) {
    return /^\d+$/.test(mobileNumber);
  }

  isMobileWithCallingCodeValid(mobileNumberWithCallingCode) {
    try {
      const phoneUtil = PhoneNumberUtil.getInstance();
      const parsedNumberWithCode = phoneUtil.parse(mobileNumberWithCallingCode);
      return phoneUtil.isValidNumber(parsedNumberWithCode);
    } catch (exception) {
      return false;
    }
  }

  componentDidUpdate() {
    if (this.state.errorMessage || this.state.invalidNumberMessageOpen) {
      this.hideTimeout = setTimeout(
        () =>
          this.setState({
            errorMessage: "",
            invalidNumberMessageOpen: false,
          }),
        5000
      );
    }
  }

  componentWillUnmount() {
    clearTimeout(this.hideTimeout);
  }

  handleEmailChange = (event) => {
    let emailText = String(event.target.value);    
    if (emailText === "") {
      this.setState({isValid: false, emailError: false, isSubmitBtnDisabled: true});
    }
    else {
      this.setState({emailValue: emailText, isValid: true, loginByEmail: true, isSubmitBtnDisabled: false, emailError: false});
    }
  }

  handleChange = (event) => {
    let mobileNumberText = String(event.target.value);
    if (
      //(this.isValidNumber(mobileNumberText)
      //&& mobileNumberText.length < 10 // REMOVING 10 digit validation
      //)||
      mobileNumberText === ""
    ) {
      this.setState({
        mobileNumberValue: mobileNumberText,
        mobileNumberError: false,
        isValid: false,
        isSubmitBtnDisabled: true,
      });
    } else if (
      //mobileNumberText.length === 10 &&
      this.isValidNumber(mobileNumberText)
    ) {
      const mobileNumberWithCallingCode =
        this.state.callingCode + mobileNumberText;
      //if (this.isMobileValid(mobileNumberText)) {
      if (this.isMobileWithCallingCodeValid(mobileNumberWithCallingCode)) {
        this.setState({
          mobileNumberValue: mobileNumberText,
          mobileNumberError: false,
          isValid: true,
          isSubmitBtnDisabled: false,
        });
      } else {
        this.setState({
          mobileNumberValue: mobileNumberText,
          mobileNumberError: true,
          isValid: false,
          isSubmitBtnDisabled: true,
        });
      }
    }
  };

  hideModal = () => {
    this.setState({
      toggleModal: false,
      mobileNumberValue: "",
    });
  };

  proceedToOtpPage = () => {
    let commoninfo = CommonUtils.getTimezone();
    //check added if user enter 0 in  mobile number starting
    let number = parsePhoneNumberFromString(
      this.state.callingCode + this.state.mobileNumberValue
    );
    let email = ""
    let modifiedNumber=""
    let requestData = {};
    if (this.state.loginByEmail) {
      email = this.state.emailValue;
      if(!email) {
        this.setState({emailError: true});
        return;
      }
      requestData = {email: email};
    }
    else {
      if (!number) {
        this.setState({mobileNumberError:true})
        return
        } 
      else {
        modifiedNumber = number.number.substring(
        this.state.callingCode.length
        );
        this.setState({mobileNumberValue:modifiedNumber,mobileNumberError:false})
        requestData = {calling_code: this.state.callingCode, mobile: modifiedNumber};
      }
    }
     

//api call to send
    if (this.state.isValid) {
      this.LoginAction.loginAction(
        //login
        requestData,
        (actionCallback) => {
          if (actionCallback.status === OperationStatus.SUCCESS) {
            this.setState({ toggleModal: true, errorMessage: "" });
          } //error handling
          else if (
            actionCallback.error.errorCode ===
              APIResponse.ACCOUNT_ALREADY_REGISTERED ||
            actionCallback.error.errorCode === APIResponse.ACCOUNT_ALREADY_EXIST
          ) {
            this.setState({
              isSignUp: false,
              toggleModal: true,
              errorMessage: actionCallback.error.errorMessage,
            });
          } else if (
            actionCallback.status === OperationStatus.NETWORK_NOT_REACHABLE
          ) {
            this.setState({
              toggleModal: false,
              isNetworkError: true,
              errorMessage: actionCallback.error.errorMessage,
            });
          } else if (
            actionCallback.error.errorCode === APIResponse.USER_NOT_FOUND
          ) {
            this.setState({
              toggleModal: false,
              mobileNotRegisteredMessageOpen: true,
              errorMessage: actionCallback.error.errorMessage,
              first_nameError: true,
            });
          } else {
            this.LoginAction.loginAction(
              //signup
              {
                first_name: this.state.isValidName
                  ? this.state.first_name
                  : undefined,
                last_name: this.state.last_name,
                timezone: commoninfo.timeZone,
                user_type: 2,
                mobile: modifiedNumber,
                calling_code: this.state.callingCode,
              },
              (actionCallback) => {
                if (actionCallback.status === OperationStatus.SUCCESS) {
                  this.setState({ toggleModal: true, errorMessage: "" });
                } else {
                  this.setState({
                    toggleModal: false,
                    mobileNotRegisteredMessageOpen: true,
                    errorMessage: actionCallback.error.errorMessage,
                  });
                }
              }
            );
          }
        }
      );
    } else {
      this.setState({
        isValid: false,
        invalidNumberMessageOpen: true,
      });
    
    }

  };

  onNameChangeHandler = (event) => {
    let name = event.target.value;
    if (!name.match(/^[a-zA-Z]+$/)) {
      this.setState({ isValidName: false, first_name: "" });
    } else {
      this.setState({ first_name: name, isValidName: true });
    }
  };
  findCountry = (CountryArray, CountryData) => {
    const matchedCountries = [];
    CountryArray.forEach((CountryInfo) => {
      let match = false;
      Object.keys(CountryData).forEach((InfoItem) => {
        if (CountryData[InfoItem] === CountryInfo[InfoItem]) {
          match = true;
        }
      });
      if (match) {
        matchedCountries.push(CountryInfo);
      }
    });
    return matchedCountries;
  };

  //google sign up
  onSuccessGoogleSignUp = (response) => {
    this.setState({ spinner: true });
    let commoninfo = CommonUtils.getTimezone();

    this.LoginAction.googleSignUp(
      {
        google_token: response.credential,
        device_type: 3,
        user_agent: "web",
        timezone: commoninfo.timeZone,
      },
      (actionCallback) => {
        this.setState({ spinner: false });
        if (actionCallback.status === OperationStatus.SUCCESS) {
          this.props.history.push(PATHS.HOME);
        } else {
          this.setState({
            toggleModal: false,
            errorMessage: actionCallback.error.errorMessage,
          });
        }
      }
    );
  };

  render() {
    const callingCode = this.state.callingCode;
    const selectedCountry = this.findCountry(FLAG_SELECTOR_OPTION_LIST, {
      id: callingCode,
    })[0];

    return (
      <div className="login">
        <CustomSpinner showModal={this.state.spinner} />
        {this.state.toggleModal ? (
          <Modal
            show={this.state.toggleModal}
            handleClose={this.hideModal}
            parent={"login"}
          >
            {
              <OtpVerificationContainer
                showVerifyModal={true}
                handleClose={this.hideModal}
                countryCallingCode={this.state.callingCode}
                mobileNumber={this.state.mobileNumberValue}
                email={this.state.emailValue}
              />
            }
          </Modal>
        ) : null}
        <div className="loginView">
          <div className="banner">
            <img
              className="loginBannerImg"
              src={LoginBannerImg}
              alt="All Well Login Page"
            />
          </div>

          <div className="rightFrame">
            <p id="websiteLink">
              <span className="infoText">{Strings("Visit")} </span>
              <a
                className="siteLinks"
                target="_blank"
                rel="noopener noreferrer"
                href="https://allwellapp.com/"
              >
                {Strings("AllWellAppSite")}
              </a>
            </p>

            <div id="loginPane">
              <div className="allWellLogoImg">
                <img src={AllWellLogoImg} alt="All Well Logo"></img>
              </div>
              <p id="careGiverText">{this.state.existingUserSignIn ? Strings("SignInSmall"): Strings("SignUpSmall")}</p>
              <div className="inputPanel">
                {!this.state.existingUserSignIn && 
                <>
                <div className="userName">
                  <div className="firstName">
                    <TextField
                      // required
                      autoComplete="off"
                      id="standard-basic"
                      label={Strings("FirstName")}
                      name={Strings("FirstName")}
                      value={this.state.first_name}
                      onChange={this.onNameChangeHandler}
                      error={this.state.first_nameError}
                      onFocus={() => this.setState({ first_nameError: false })}
                    />
                  </div>
                  <div className="lastname">
                    <TextField
                      id="standard-basic"
                      autoComplete={"off"}
                      label={Strings("LastName") + Strings("Optional")}
                      value={this.state.last_name}
                      onChange={(event) => {
                        if (event.target.value.match(/^[a-zA-Z]+$/)) {
                          this.setState({ last_name: event.target.value });
                        } else {
                          this.setState({ last_name: "" });
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="mobileNumberSection">
                  <div className="callingCodePicker">
                    <label className={"callingCodeLabel"}>
                      {Strings("Country")}
                    </label>
                    <ReactCustomFlagSelect
                      tabIndex={"1"}
                      id={"callingCode"}
                      name={"callingCode"}
                      value={selectedCountry.id}
                      showSearch={true}
                      showArrow={true}
                      animate={true}
                      optionList={FLAG_SELECTOR_OPTION_LIST}
                      customStyleContainer={{
                        border: "none",
                        fontSize: "12px",
                      }}
                      customStyleSelect={{
                        width: "100%",
                        height: "25px",
                        padding: "0px 20px",
                      }}
                      customStyleOptionListContainer={{
                        margin: "0px",
                        maxHeight: "155px",
                        overflow: "auto",
                        width: "130px",
                      }}
                      onChange={(CallingCode) => {
                        this.setState({
                          callingCode: CallingCode,
                          mobileNumberValue: "",
                        });
                      }}
                    />
                  </div>
                  <div className="mobileNumberBlock">
                    <TextField
                      id="standard-basic"
                      autoComplete={"off"}
                      className="mobileNumberField"
                      onKeyPress={this.enterPress_Login}
                      onChange={this.handleChange}
                      value={this.state.mobileNumberValue}
                      error={this.state.mobileNumberError}
                      label="Mobile Number"
                    />
                  </div>
                </div>
                </>
                }
                {
                  this.state.existingUserSignIn && 
                  <>
                    <div className="mobileNumberSection">
                      <div className="callingCodePicker">
                        <label className={"callingCodeLabel"}>
                          {Strings("Country")}
                        </label>
                        <ReactCustomFlagSelect
                          tabIndex={"1"}
                          id={"callingCode"}
                          name={"callingCode"}
                          value={selectedCountry.id}
                          showSearch={true}
                          showArrow={true}
                          animate={true}
                          optionList={FLAG_SELECTOR_OPTION_LIST}
                          customStyleContainer={{
                            border: "none",
                            fontSize: "12px",
                          }}
                          customStyleSelect={{
                            width: "100%",
                            height: "25px",
                            padding: "0px 20px",
                          }}
                          customStyleOptionListContainer={{
                            margin: "0px",
                            maxHeight: "155px",
                            overflow: "auto",
                            width: "130px",
                          }}
                          onChange={(CallingCode) => {
                            this.setState({
                              callingCode: CallingCode,
                              mobileNumberValue: "",
                            });
                          }}
                        />
                      </div>
                      <div className="mobileNumberBlock">
                        <TextField
                          id="standard-basic"
                          autoComplete={"off"}
                          className="mobileNumberField"
                          onKeyPress={this.enterPress_Login}
                          onChange={this.handleChange}
                          value={this.state.mobileNumberValue}
                          error={this.state.mobileNumberError}
                          label="Mobile Number"
                        />
                      </div>
                    </div>
                    <br/>
                    <Divider text={Strings("OR")}></Divider>
                    <div className="emailSection">
                      <div className="emailBlock">
                          <TextField
                            id="standard-basic"
                            autoComplete={"off"}
                            className="emailField"
                            onChange={this.handleEmailChange}
                            error={this.state.emailError}
                            label="Email"
                          />
                      </div>
                    </div>
                  </>
                }              
              </div>
              <div className="loginBtnWrapper">
                <Button
                  className="loginBtn"
                  disabled={this.state.isSubmitBtnDisabled}
                  onClick={this.proceedToOtpPage}
                >
                  {Strings("Submit")}
                </Button>
                {this.state.existingUserSignIn && 
                <>
                <span>
                  <a
                    className="goBackBtn" onClick={()=>{this.setState({existingUserSignIn: false})}}>
                    {"GO BACK"}
                  </a>
                </span>
                </>
                }
              </div>

              {this.state.errorMessage ? (
                <Alert color="danger" className="alertMessage">
                  {this.state.errorMessage}
                </Alert>
              ) : null}
              {this.state.invalidNumberMessageOpen ? (
                <Alert color="danger" className="alertMessage">
                  {Strings("ERROR_INVALID_MOBILE_NUMBER")}
                </Alert>
              ) : null}

              {/* email sign in */}
              {
                !this.state.existingUserSignIn && 
                (<>
                  <div className="ExistingUserLoginBtnWrapper">
                    <Divider text={Strings("OR")} />
                    <Button className="existingUserLoginBtn" onClick={()=>{this.setState({existingUserSignIn: true})}}>Existing User? Sign In</Button>
                  </div>
                </>)
              }
              
              {/* google sign in */}
            <GoogleOAuthProvider clientId={GOOGLE_WEB_CLIENT_ID}>
              <div className="googleSignIn">
                <Divider text={Strings("OR")} />
                <GoogleLogin
                  className="GoogleSignInBtn"
                  onSuccess={(responseGoogle) => {
                    this.onSuccessGoogleSignUp(responseGoogle)
                  }}
                  onError={(responseError) => {
                    console.log('Google login failed!')
                  }}
                  useOneTap
                >
                  <span className="googleLetter">
                    <img src={ic_google} alt="ic_google" />
                  </span>
                  {Strings("GoogleSignInBtn")}
                </GoogleLogin>
              </div>
            </GoogleOAuthProvider>
              <div className="termesText">
                <span>{Strings("OtpTextInfo")}</span>
              </div>
              <div className="termesText">
                <span>By using All Well, you agree to our </span>
                <span id="termsLink">
                  <a
                    className="siteLinks"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://allwellapp.com/terms-of-use/"
                  >
                    {Strings("TermsConditions")}
                  </a>
                  <span> | </span>
                  <a
                    className="siteLinks"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://allwellapp.com/privacy-policy/"
                  >
                    {Strings("PrivacyPolicy")}
                  </a>
                </span>
              </div>

              {/* //show demo data */}
              <div className="showDemoDataBtnWrapper">
                <Button
                  className="loginBtn"
                  onClick={() => {
                    this.props.history.push(PATHS.SHOWDEMO);
                  }}
                >
                  {Strings("ShowDemo")}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentUserInfo:
      state.OtpVerification.currentUserInfo &&
      state.OtpVerification.currentUserInfo.id
        ? state.OtpVerification.currentUserInfo
        : state.Login.currentUserInfo,

    userdetails: state.userdetails,
    inviteTokenInfo: state.InvitationHandler.accessInfo,
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}
export default connect(mapStateToProps, matchDispatchToProps)(Login);
